'use client';

import { createContext, useContext } from 'react';

import type { AuthUserProfile } from '@/stores/auth-store';

export const ResolvedAuthUserContext = createContext<AuthUserProfile | null>(null);

export function useResolvedAuthUser(): AuthUserProfile | null {
  return useContext(ResolvedAuthUserContext);
}
